import axios from "axios";

/**@Constants */
import { base_URL } from "../config/config";

// Function to fetch vendor response time
export const fetchVendorResponseTime = async (vendorId) => {
  try {
    const { data } = await axios.get(
      `${base_URL}/api/vendor-response-time/${vendorId}`
    );
    return data;
  } catch (error) {
    console.error("Error fetching response time:", error.message);
    return { averageResponseTime: 0, totalEnquiries: 0 };
  }
};

export const deleteVendor = async (id) => {
  const accessToken = localStorage.getItem("adminAccessToken");
  const response = await fetch(`${base_URL}/api/vendor/${id}`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  });
  if (!response.ok) {
    throw new Error('Failed to delete');
  }
  return await response.json();
};  